import { Button } from '../../ui/button';
import { CheckCircle, FileX, LucideProps } from 'lucide-react';
import { Badge } from '../../ui/badge';
import { formatDate } from '@/utils/formatDate';
import { cn } from '@/components/ui/utils';

interface WorkflowButtonProps {
  disabled?: boolean;
  onClick: () => void;
  isContentGenerated: boolean;
  Icon: React.ForwardRefExoticComponent<
    Omit<LucideProps, 'ref'> & React.RefAttributes<SVGSVGElement>
  >;
  title: string;
  generatedAt?: string | null;
  className?: string;
}

export const WorkflowButton: React.FC<WorkflowButtonProps> = ({
  disabled,
  onClick,
  isContentGenerated,
  Icon,
  generatedAt,
  title,
  className,
}) => (
  <Button
    variant={isContentGenerated ? 'secondary' : 'outline'}
    size='sm'
    onClick={onClick}
    disabled={disabled}
    className={cn(`justify-start gap-2 h-auto py-3`, className)}
  >
    <div className='flex items-center justify-between w-full'>
      <div className='flex items-center gap-2'>
        <Icon className='h-4 w-4' />
        <span>{title}</span>
        {isContentGenerated ? (
          <CheckCircle className='h-3 w-3 text-green-600' />
        ) : (
          <FileX className='h-3 w-3 text-muted-foreground' />
        )}
      </div>
      {generatedAt && (
        <Badge variant='secondary' className='text-xs'>
          {formatDate(generatedAt)}
        </Badge>
      )}
    </div>
  </Button>
);
